module.exports = __webpack_public_path__ + "fonts/Canaro-SemiBold.1afa844b.woff2";